
import { Component, Input } from '@angular/core';
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { RoutesPath } from '../../../../../shared/constants/routes-path';
import { SharedService } from '../../../../../shared/services/shared.service';

@Component({
  selector: 'app-membership-activities',
  imports: [TranslateModule],
  templateUrl: './membership-activities.component.html',
  styleUrl: './membership-activities.component.scss'
})
export class MembershipActivitiesComponent {
  @Input() activities: any[] = [];
  lang:string="en";
  
  constructor(
    private router: Router,
    private sharedService:SharedService
  ) {
     this.lang = this.sharedService.getCurrentLang();
  }

  updateMembership() {
    this.router.navigate([RoutesPath.SERVICE+"/"+RoutesPath.MEMBERSHIP.REGISTRATION])
  }
}
